import { useTranslation } from 'libs/i18n'

export const useActionFilters = (isDisabled: boolean) => {
	const { t } = useTranslation()

	return [
		{
			id: 'actions',
			label: t('Actions'),
			placeholder: t('Default'),
			options: [
				{
					value: 'payout',
					label: t('Prepare payout'),
					isDisabled
				},
				{
					value: 'emailPayoutReminder',
					label: t('Send payout method reminder email'),
					isDisabled
				},
				{
					value: 'export',
					label: t('Export users')
				}
			]
		}
	]
}
